import React from "react";
import { RequestAllocationDesktop } from "./RequestAllocationCard";

export function InvestDesktop({
	offer,
}: React.ComponentProps<typeof RequestAllocationDesktop>) {
	if (offer.status === "OPEN" || offer.status === "OVERSUBSCRIBED") {
		return <RequestAllocationDesktop offer={offer} />;
	}

	if (offer.status === "CLOSED" || offer.status === "PRE_OPEN") {
		return null;
	}

	return offer.status satisfies never;
}
